module.exports = __webpack_public_path__ + "static/media/27OCHA14.8c7f2f8e.jpg";